import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const galleryItems = [
  {
    url: 'https://images.unsplash.com/photo-1765218933298-dc55fdfb517a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxzdGFpbmxlc3MlMjBzdGVlbCUyMGZhY3Rvcnl8ZW58MHx8fHwxNzc1NTAyNzU1fDA&ixlib=rb-4.1.0&q=85',
    sector: { en: 'Industrial', fr: 'Industriel' },
  },
  {
    url: 'https://images.pexels.com/photos/7598915/pexels-photo-7598915.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    sector: { en: 'Processing', fr: 'Transformation' },
  },
  {
    url: 'https://images.unsplash.com/photo-1748347568194-c8cd8edd27da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxzdGFpbmxlc3MlMjBzdGVlbCUyMGZhY3Rvcnl8ZW58MHx8fHwxNzc1NTAyNzU1fDA&ixlib=rb-4.1.0&q=85',
    sector: { en: 'Manufacturing', fr: 'Fabrication' },
  },
  {
    url: 'https://images.unsplash.com/photo-1548945665-56d2712b4986?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxzdGFpbmxlc3MlMjBzdGVlbCUyMHdlbGRpbmd8ZW58MHx8fHwxNzc1NTAyNzM3fDA&ixlib=rb-4.1.0&q=85',
    sector: { en: 'Welding', fr: 'Soudure' },
  },
  {
    url: 'https://images.unsplash.com/photo-1651260414968-7f27e8db866f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxtaW5pbmclMjBlcXVpcG1lbnR8ZW58MHx8fHwxNzc1NTAyNzU1fDA&ixlib=rb-4.1.0&q=85',
    sector: { en: 'Mining Equipment', fr: 'Equipement Minier' },
  },
  {
    url: 'https://images.unsplash.com/photo-1708201267130-46d12abe74cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxzdGFpbmxlc3MlMjBzdGVlbCUyMHdlbGRpbmd8ZW58MHx8fHwxNzc1NTAyNzM3fDA&ixlib=rb-4.1.0&q=85',
    sector: { en: 'Custom Work', fr: 'Sur Mesure' },
  },
];

export default function GallerySection() {
  const { t, lang } = useLanguage();
  const [hoveredIdx, setHoveredIdx] = useState(null);

  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 lg:py-32 bg-[#F8F8F7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-8 h-px bg-[#003865]" />
            <span
              className="text-xs font-bold uppercase tracking-[0.2em] text-[#003865]"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              {t('gallery.overline')}
            </span>
            <div className="w-8 h-px bg-[#003865]" />
          </div>
          <h2
            data-testid="gallery-title"
            className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#333F48] mb-4"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            {t('gallery.title')}
          </h2>
          <p
            className="text-base text-[#333F48]/60 max-w-xl mx-auto"
            style={{ fontFamily: 'Roboto, sans-serif' }}
          >
            {t('gallery.subtitle')}
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {galleryItems.map((item, i) => (
            <div
              key={i}
              data-testid={`gallery-item-${i}`}
              className="relative overflow-hidden border border-[#C8C9C7] aspect-[4/3] cursor-pointer group"
              onMouseEnter={() => setHoveredIdx(i)}
              onMouseLeave={() => setHoveredIdx(null)}
            >
              <img
                src={item.url}
                alt={item.sector[lang]}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div
                className={`absolute inset-0 bg-[#333F48]/80 flex items-end p-6 transition-opacity duration-300 ${
                  hoveredIdx === i ? 'opacity-100' : 'opacity-0'
                }`}
              >
                <span
                  className="text-sm font-bold uppercase tracking-widest text-white"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {item.sector[lang]}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
